import { createContext, useContext } from 'react'

import {
  GetCountryDataInputs,
  OnCountryDataFieldChange,
} from 'modules/contracts/lib/useCountryDataInputs'

interface CountryDataInputsContextValue {
  updateCountryDataField: OnCountryDataFieldChange
  getCountryDataInputs: GetCountryDataInputs
}

const CountryDataInputsContext = createContext<CountryDataInputsContextValue | null>(null)

export const CountryDataInputsProvider = CountryDataInputsContext.Provider

export const useCountryDataFieldChange = () => {
  const ctx = useContext(CountryDataInputsContext)
  return ctx?.updateCountryDataField
}

export const useGetCountryDataInputs = () => {
  const ctx = useContext(CountryDataInputsContext)
  return ctx?.getCountryDataInputs
}
